export function toFixed(value) {
  if (!value) return '0.00';
  return parseFloat(value).toFixed(2);
}